<template>
  <div class="p-the-page-e01 c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheHeader ref="theHeader" />
      <div class="c-common-inner">
        <TheBreadcrumb />
      </div>
      <div class="c-common-inner p-the-page-e01__inner">
        <div class="p-the-page-e01__body">
          <p class="p-the-page-e01__heading">お気に入り</p>
          <div class="p-the-page-e01__content">
            <template v-if="itemListData.length > 0">
              <ul class="p-the-page-e01__items">
                <ItemListPanelLarge
                  v-for="(item, key) in itemListData"
                  :id="item.id"
                  :key="key"
                  :page="page"
                  :premium-id="item.premium_id"
                  :thumbnails="item.thumbnails"
                  :status="item.status"
                  :name="item.name"
                  :point="item.point"
                  :discount-rate="item.discount_rate"
                  :is-cart="item.is_cart"
                  :stock="item.stock"
                  :stock-control="item.is_quantity_control"
                  :type="item.type"
                  :color="item.colorCode"
                  :supplier-creditcard="item.supplier_creditcard"
                  :used-points-after-add-to-cart="usedPointsAfterAddToCart"
                  :options="item.options"
                  :age-alert="item.is_age_alert"
                  @delete="onDelete(item.favorite_id)"
                />
              </ul>
            </template>
            <ItemEmptyPanel
              v-else
              text="お気に入りアイテムの登録はありません"
              type="favorite"
            />
          </div>
          <ItemCarouselGroup
            :histories="histories"
            :recommendations="recommendations"
            :favorites="favorites"
          />
        </div>
      </div>
    </div>
    <TheFooter />
  </div>
</template>

<script lang="ts">
import { mapState } from "vuex";
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import ItemCarouselGroup from "@/general/components/organisms/ItemCarouselGroup.vue";
import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import ItemListPanelLarge from "@/general/components/molecules/ItemListPanelLarge.vue";
import ItemEmptyPanel from "@/general/components/molecules/ItemEmptyPanel.vue";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";
import { Options, Vue } from "vue-class-component";
import {
  browserHistory,
  deleteFavorites,
  getFavorites,
  getProductList,
  getShoppingCartPointSummary,
  productDetail
} from "@/general/store/api";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import items from "@/general/store/modules/items";

import { karteView, karteItem, karteFavorite } from "@/common/assets/js/karte/";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";

@Options({
  components: {
    TheHeader,
    TheFooter,
    ItemCarouselGroup,
    CommonHeading,
    ItemListPanelLarge,
    ItemEmptyPanel,
    TheBreadcrumb
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  }
})
export default class Favorite extends Vue {
  itemListData: any = [];

  histories: any = [];
  recommendations: any = [];
  favorites: any = [];
  usedPointsAfterAddToCart = 0;

  breadcrumb: any = [
    {
      text: "",
      url: "/home",
      pageType: "home"
    },
    {
      text: "お気に入り",
      url: "/",
      pageType: "lower"
    }
  ];

  declare $refs: {
    theHeader: TheHeader;
  };

  page = "favorite";

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }


  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    await commons.setbreadcrumb(this.breadcrumb);
    const favorites = await getFavorites();
    favorites.results?.forEach((item) => {
      this.itemListData.push({
        favorite_id: item?.id,
        id: item?.sku?.id,
        premium_id: item?.sku?.premium?.id,
        thumbnails: [
          {
            path: this.getImagePath(item?.sku?.premium)
          }
        ],
        status: this.status(item?.sku),
        name: item?.sku?.premium?.name,
        point: item?.sku?.point_required,
        discount_rate: 0,
        is_cart: this.cartSkuIds.includes(item?.sku?.id),
        stock: item?.sku?.quantity,
        is_quantity_control: item?.sku?.is_quantity_control,
        type: item.sku.premium.redemption_type == 1 ? "normal" : "gift_card",
        supplier_creditcard: item?.sku?.supplier?.credit_card_support,
        options: item?.sku?.options,
        is_age_alert: item?.sku?.premium?.is_age_alert,
        colorCode: this.getColor(item?.sku)
      });
    });

    const cartSummary = await getShoppingCartPointSummary().catch(() => {
      return { used_points: 0 };
    });

    this.usedPointsAfterAddToCart = cartSummary?.used_points;

    await this.getRecommendation();
    await this.getHistories();
  }

  mounted() {
    karteView();

    AuthStorage.checkLogin();
  }

  async onDelete(id: number) {
    const product = await productDetail(id);

    karteFavorite(false, karteItem(product, 0));

    await deleteFavorites(id);
    window.location.href = "/favorites";
  }

  get cartSkuIds() {
    return LocalStorage.getItem("cartSkuIds")
      ? JSON.parse(LocalStorage.getItem("cartSkuIds") as string)
      : [];
  }

  status(sku: any) {
    if (sku?.is_quantity_control && sku?.quantity == 0) {
      //out of stock
      return "在庫なし";
    } else if (sku?.premium?.is_new === true) {
      //New
      return "New";
    } else if (sku?.premium?.is_featured === true) {
      //Recommended
      return "おすすめ";
    } else {
      //show nothing
      return "";
    }
  }

  async getHistories() {
    const favorites = await browserHistory();
    favorites.results?.forEach((item) => {
      this.histories.push({
        id: item?.sku?.premium?.id,
        image: this.getImagePath(item?.sku?.premium),
        name: item?.sku?.premium?.name,
        point: item?.sku?.point_required,
        discount_rate: 0,
        is_favorite: false,
        stock: item?.sku?.quantity,
        is_quantity_control: item?.sku?.is_quantity_control,
        colorCode: this.getColor(item?.sku),
        status: this.status(item?.sku)
      });
    });
  }

  async getRecommendation() {
    const recommendations = await getProductList(
      1,
      8,
      undefined,
      undefined,
      undefined,
      undefined,
      "recommended",
      undefined
    );

    const result = recommendations?.results;

    result?.forEach((item) => {
      this.recommendations.push({
        id: item?.premium?.id,
        image: this.getImagePath(item?.premium),
        name: item?.premium?.name,
        point: item?.point_required,
        discount_rate: 0,
        is_favorite: false,
        stock: item?.quantity,
        is_quantity_control: item?.is_quantity_control,
        colorCode: this.getColor(item),
        status: this.status(item)
      });
    });
  }

  getImagePath(premium: any) {
    let imgUrl = "";
    premium?.premiumimage_set?.forEach((img: any) => {
      if (img?.is_primary == true) {
        imgUrl = img?.image_url;
      }
    });

    return imgUrl;
  }

  getColor(item: any) {
    return item.is_quantity_control && item.quantity == 0
      ? "#333"
      : commons.colorCode;
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-e01 {
  // TODO: 最大幅が1080pxのページ他にもあるかも
  &__inner {
    max-width: rem(1080);
  }

  &__body {
    padding: rem(32) 0 rem(56);

    @include large-sp {
      padding: rem(32) 0 rem(48);
    }
  }

  &__heading {
    @include text__title--s;
  }

  &__content {
    margin-top: rem(24);

    @include large-sp {
      margin-top: rem(16);
    }
  }

  &__items {
    padding-bottom: rem(40);
  }
}
</style>
